import Link from '@mui/material/Link';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Tooltip from '@mui/material/Tooltip';
import { useAtom } from 'jotai';

import { organizationsAtom } from '@/pages/Organizations';
import { isLayoutMobileAtom } from '@/store/layout';
import { isSidebarExpandedAtom, isSidebarOpenAtom } from '@/store/sidebar';

import useStyles from '../Sidebar.styles';
import type { SidebarLinkButtonProps } from './SidebarLinkButton.types';

function SidebarLinkButton(props: SidebarLinkButtonProps) {
  const { item } = props;
  const [isLayoutMobile] = useAtom(isLayoutMobileAtom);
  const [organizations] = useAtom(organizationsAtom);
  const [, setIsSidebarOpen] = useAtom(isSidebarOpenAtom);
  const [isSidebarExpanded] = useAtom(isSidebarExpandedAtom);
  const { classes } = useStyles({
    isLayoutMobile,
    isSidebarExpanded,
    organizationsLengthEqualToOne: organizations.length === 1
  });

  const handleClick = () => {
    if (isLayoutMobile) {
      setIsSidebarOpen(false);
    }
  };

  return (
    <Tooltip
      arrow
      placement="right"
      title={!isSidebarExpanded ? item.label : null}
      classes={{
        arrow: classes.sidebarButtonTooltipArrow,
        tooltip: classes.sidebarButtonTooltip
      }}
      slotProps={{
        popper: {
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, -5]
              }
            }
          ]
        }
      }}
    >
      <ListItem className={classes.sidebarButton} disablePadding>
        <Link
          color="primary"
          href={item.link}
          rel="noreferrer"
          target="_blank"
          underline="none"
        >
          <ListItemButton
            className={classes.sidebarButtonButton}
            onClick={handleClick}
          >
            <div>
              <ListItemIcon className={classes.sidebarButtonIcon}>
                {item.component}
              </ListItemIcon>
              <ListItemText
                className={classes.sidebarButtonText}
                primary={item.label}
              />
            </div>
          </ListItemButton>
        </Link>
      </ListItem>
    </Tooltip>
  );
}

export default SidebarLinkButton;
